import * as React from 'react'

function SvgLa(props) {
	return (
		<svg viewBox="0 0 600 400" width="1em" height="1em" {...props}>
			<path fill="#ce1126" d="M0 0h600v400H0z" />
			<path fill="#002868" d="M0 100h600v200H0z" />
			<circle fill="#fff" cx={300} cy={200} r={80} />
		</svg>
	)
}

export default SvgLa
